export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section data-testid="page-hero" className="pt-16 md:pt-24 pb-12 md:pb-20 border-b border-slate-200" style={{ background: "var(--zt-bg-alt)" }}>
      <div className="zt-container">
        {eyebrow && <p className="zt-overline mb-5">{eyebrow}</p>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed mt-6 max-w-3xl">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
